import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core'
import { EventLocationEntity } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.models'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import { EventTicketsFacade } from 'libs/gb-front/event-tickets/data-access/src/lib/+state/event-tickets.facade'
import * as Color from 'color'

@Component({
  selector: 'gb-event-ticket-dialog',
  templateUrl: './gb-event-ticket-dialog.component.html',
  styleUrls: ['./gb-event-ticket-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbEventTicketDialogComponent {
  selectedEventTicket$ = this.eventTicketsFacade.selectedEventTicket$
  auction$ = this.auctionFacade.auction$

  constructor(private eventTicketsFacade: EventTicketsFacade, private auctionFacade: AuctionFacade) {}

  isLightPrimaryColor(primaryColor = ''): boolean {
    const color = Color(primaryColor)
    return color.isLight()
  }

  getEventLocation(eventLocation: EventLocationEntity | undefined): string {
    if (!eventLocation) {
      return ''
    }
    if (!eventLocation?.name) {
      return eventLocation?.address
    }
    return `${eventLocation?.name} ${eventLocation?.address}`
  }

  getEventLatLong(eventLocation: EventLocationEntity | undefined): string {
    if (!eventLocation) {
      return ''
    }
    return `${eventLocation?.latitude}, ${eventLocation?.longitude}`
  }

  getEventHour(dates: string[] | undefined, timezone = 'UTC'): string {
    if (!dates || dates.length === 0) {
      return ''
    }

    const date = new Date(dates[0])
    return date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: timezone,
    })
  }

  getEventDate(dates: string[] | undefined, timezone = 'UTC'): string {
    if (!dates || dates.length === 0) {
      return ''
    }

    const date = new Date(dates[0])

    // using undefined as the first argument will use the default locale from the
    // browser for the user's location
    // like in US Wed, January 9, 2024
    // like in AU Wed, 9 January 2024
    return date.toLocaleDateString(undefined, {
      weekday: 'short',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: timezone,
    })
  }
}
